// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2752":"384140f9","5705":"3a5c574d","9947":"d6088115"}[chunkId] || chunkId) + "." + {"2173":"91395cb3a9b83321","2741":"653c787f2490dc24","2752":"a9fb2ccde93718d3","5705":"0466e6b59dd5d644","5951":"429fb1f350d95eba","9651":"bddd959a7c85efc2","9947":"9beeacec0cc97694"}[chunkId] + ".js";
};